var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.8337C14.6017 18.8337 18.3327 15.1027 18.3327 10.5003C18.3327 5.89795 14.6017 2.16699 9.99935 2.16699C5.39698 2.16699 1.66602 5.89795 1.66602 10.5003C1.66602 15.1027 5.39698 18.8337 9.99935 18.8337Z",
    fill: "#EDB900",
    stroke: "#EDB900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.833H12.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 9.66699L7.08398 8.41699M7.08398 8.41699L5.83398 7.16699M7.08398 8.41699L5.83398 9.66699M7.08398 8.41699L8.33398 7.16699M14.1673 9.66699L12.9173 8.41699M12.9173 8.41699L11.6673 7.16699M12.9173 8.41699L11.6673 9.66699M12.9173 8.41699L14.1673 7.16699",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractOverviewIcon);
export default __webpack_public_path__ + "static/media/contract_overview_icon.3a7276d69e999b5b610e85d8d9196843.svg";
export { ForwardRef as ReactComponent };